__turbopack_context__.v({
  "cardContainer": "serviceCardsCard-module-scss-module__iXWUZG__cardContainer",
  "cardDescription": "serviceCardsCard-module-scss-module__iXWUZG__cardDescription",
  "cardTitle": "serviceCardsCard-module-scss-module__iXWUZG__cardTitle",
  "cardWrapper": "serviceCardsCard-module-scss-module__iXWUZG__cardWrapper",
});
